<template>
<div id="app">
  <water-mark ref="waterMark"></water-mark>
  <router-view></router-view>
  <div class="help" :style="'bottom:' + bottom + 'px;right:' + right + 'px'" @click="openHelp" @dragstart="startDrag" @dragend="endDrag"  draggable="true">
    <img src="static/help.png" width="30px">
    <span class="helpTitle">常见问题</span>
  </div>
</div>
</template>

<script>
import Util from './lib/util.js'
import WaterMark from "./components/waterMark/waterMark.vue";
import roomOrders from './views/basic/room/roomOrders'
export default {
  name: 'App',
  components: {WaterMark},
  data(){
    return {
      bottom: 50,
      right: 50,
      startX: -1,
      startY: -1
    }
  },
  mounted() {
    let position = JSON.parse(localStorage.getItem("helpPosition"))
    if(position){
      this.bottom = position.bottom
      this.right = position.right
    }else {
      position = {bottom: 50, right: 50}
      localStorage.setItem("helpPosition", JSON.stringify(position))
    }
    this.systemName()
  },
  computed: {

  },
  updated() {
    this.$nextTick(() => {
      this.$refs.waterMark.initCan()
    });
  },
  methods: {
    startDrag(e){
      this.startX = e.clientX
      this.startY = e.clientY
    },
    endDrag(e){
      let moveX = e.clientX - this.startX
      let moveY = e.clientY - this.startY
      let oldPosition = JSON.parse(localStorage.getItem("helpPosition"))
      if(!oldPosition){
        oldPosition = {bottom: 50, right: 50}
      }
      let bottom = oldPosition.bottom - moveY
      if(bottom < 20){
        bottom = 20
      }
      if(bottom >= document.body.clientHeight - 70){
        bottom = document.body.clientHeight - 70
      }
      let right = oldPosition.right - moveX
      if(right < 20){
        right = 20
      }
      if(right >= document.body.clientWidth - 70){
        right = document.body.clientWidth - 70
      }
      this.bottom = bottom
      this.right = right
      let position = {bottom: bottom, right: right}
      localStorage.setItem("helpPosition", JSON.stringify(position))
    },
    openHelp(){
      if(top.location.href.indexOf("/login") > -1){
        this.$router.push('/oa/help/question/2/1')
      }else {
        this.$router.push('/oa/help/question')
      }
    },
    systemName() {
      if (this.$store.state.projectName) {
        document.title = (this.$store.state.projectName ? this.$store.state.projectName : '正德信事务所') + '管理系统'
      } else {
        document.title = '正德信事务所管理系统'
      }
      if (this.$store.state.logo) {
        this.logo = Util.resourceURL.resourceURL + this.$store.state.logo
        var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
        link.type = 'image/x-icon'
        link.rel = 'shortcut icon'
        link.href = this.logo
        document.getElementsByTagName('head')[0].appendChild(link)
      }
    },
  },
  watch: {
    '$route': {
      handler(to, from) {
        setTimeout(() => { //避免首次获取不到window._czc
          if (window._czc) {
            let location = window.location;
            let contentUrl = location.pathname + location.hash;
            let refererUrl = '/';
            // 用于发送某个URL的PV统计请求，
            window._czc.push(['_trackPageview', contentUrl, refererUrl])
          }
        }, 300)
      },
      immediate: true  // 首次进入页面即执行
    }
  }
}
</script>

<style lang="less">
.size {
  width: 100%;
  height: 100%;
}

html {
  .size;
  overflow-x: auto;
  margin: 0;
  padding: 0;
  //min-width: 1366px;
}

img {
  object-fit: cover
}

#app {
  .size;
}
</style>
<style>
  .help {
    position: fixed;
    bottom: 30px;
    right: 50px;
    text-align: center;
    width: 62px;
    height: 62px;
    border: #409eff 1px solid;
    border-radius: 50%;
    z-index: 9999;
    background-color: #FFFFFF;
    cursor: pointer;
    color: #409eff;
    overflow: hidden;
  }
  .help:hover{
    background-color: #409eff;
    color: #FFFFFF;
  }
  .help img{
    filter: drop-shadow(50px 0 #409eff);
    position: relative;
    left: -50px;
  }
  .help:hover img{
    color: #FFFFFF;
    filter: drop-shadow(50px 0 #FFFFFF);
  }
  .helpTitle{
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue